module.exports = __webpack_public_path__ + "img/repayment-peopel-total-number.adb0d4c9.svg";